module.exports = __webpack_public_path__ + "media/images/icon-svg/cart-4-f36c31869d8acb87cc1e04ec828492aa.svg";